import * as S from "./styles";
import React from "react";
import LinkMenu from "../LinkMenu/LinkMenu";
import { MENU_LINKS, PROFILE_MENU } from "../../../utils/models/navbar";
import { Link } from "react-router-dom";
import { useMainState } from "modules/app/contexts";
import { useTranslation } from "react-i18next";

export default function NavBar({ whatsappOn, credentials }) {
  const { user, company } = useMainState();
  const { t } = useTranslation(["Widget", "Conect"]);

  return (
    <S.AppBar position="fixed">
      <S.BarContainer>
        <S.Section className="logo">
          <Link to="/app" style={{ textDecoration: "none" }}>
            <S.CompanyName variant="h6" noWrap>
              C2Sgo
            </S.CompanyName>
          </Link>

          {credentials?.length > 0 && (
            <Link
              to={user.role == "manager" ? "/app/credentials" : "/app"}
              style={{ textDecoration: "none" }}
            >
              <S.WhatsappStatus whatsappOn={whatsappOn}>
                {whatsappOn ? t("Conect:conected") : t("Conect:disconected")}
              </S.WhatsappStatus>
            </Link>
          )}
        </S.Section>

        <S.Section>
          {MENU_LINKS.map((link) => (
            <LinkMenu key={link.name} link={link} />
          ))}
        </S.Section>

        <S.Section direction="rtl">
          <LinkMenu link={PROFILE_MENU} />
          <S.WidgetCountainer>
            <S.Widget
              widget="https://announcekit.co/widgets/v2/Hf4Qw"
              user={{
                id: user?.id,
                name: user?.name,
                email: user?.email,
              }}
              data={{
                company_name: company?.name,
                active: user?.status === "active",
                is_recipient: user?.receive_lead === true,
                role: user?.role,
              }}
            >
              <S.WidgetSpan>{t("Widget:whats_news")}</S.WidgetSpan>
            </S.Widget>
          </S.WidgetCountainer>
        </S.Section>
      </S.BarContainer>
    </S.AppBar>
  );
}
